import { render, staticRenderFns } from "./ContactPanel.vue?vue&type=template&id=624717be&scoped=true&"
import script from "./ContactPanel.vue?vue&type=script&lang=js&"
export * from "./ContactPanel.vue?vue&type=script&lang=js&"
import style0 from "./ContactPanel.vue?vue&type=style&index=0&id=624717be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624717be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('624717be')) {
      api.createRecord('624717be', component.options)
    } else {
      api.reload('624717be', component.options)
    }
    module.hot.accept("./ContactPanel.vue?vue&type=template&id=624717be&scoped=true&", function () {
      api.rerender('624717be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/conversation/ContactPanel.vue"
export default component.exports